import { TreeItemType } from "../enums";
import { ITreeItem } from "../interfaces";
import { BreadcrumbProjectModel } from "./BreadcrumbProjectModel";
import { NamespaceModel } from "./NamespaceModel";
import { QueueTasksModel } from "./QueueTasksModel";

/**
 * * Модель группы
 */
export class GroupModel implements ITreeItem {
  /**Id группы */
  Id!: number;
  /**Название группы */
  Name!: string;
  /**ID рабочей области */
  NamespaceId?: string;
  /**ID родительской группы */
  ParentGroupId?: number;
  /**Группа */
  Group?: GroupModel;
  /**Очередь задач */
  QueueTask?: QueueTasksModel;
  /**Тип в дереве */
  readonly Type: TreeItemType = TreeItemType.Group;

  /**Является ли объект рабочей областью */
  isNamespace = (): this is NamespaceModel => false;
  /**Является ли объект группой */
  isGroup = (): this is GroupModel => true;
  /**Является ли объект очередью */
  isQueue = (): this is QueueTasksModel => false;
  /**Является ли объект проектом */
  isProject = (): this is BreadcrumbProjectModel => false;

  constructor(obj?: Partial<GroupModel>) {
    if (obj.Group && obj.QueueTask)
      throw new Error("В группе могут быть либо группа, либо очередь задач");
    if (obj) Object.assign(this, { ...obj, Type: this.Type });
  }
}
